import Model, { attr, hasMany, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class PermissionModel extends Model {
  @attr('string') permission!: string;
  @attr('boolean') permitted!: boolean;
  @attr('boolean', { allowNull: true }) permittedByDefault!: boolean | null;
  @attr('string') title!: string;
  @attr('string') category!: string;
  @attr('string-or-empty') subCategory!: string;

  @belongsTo('permission', { inverse: 'children', async: false })
  parent?: ModelRegistry['permission'];

  @hasMany('permission', { inverse: 'parent', async: false })
  children?: ModelRegistry['permission'][];

  @belongsTo('client', { inverse: 'permissions', async: false })
  client!: ModelRegistry['client'];

  @belongsTo('user', { inverse: 'permissions', async: false })
  user!: ModelRegistry['user'];

  @belongsTo('teammate', { inverse: 'permissions', async: false })
  teammate!: ModelRegistry['teammate'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    permission: PermissionModel;
  }
}
